import * as Yup from 'yup';

const faqSchema = Yup.object().shape({
  language: Yup.string().required('Language is required.'),
  items: Yup.array().of(
    Yup.object().shape({
      categoryName: Yup.string().required('Category is required.'),
      qaList: Yup.array().of(
        Yup.object().shape({
          question: Yup.string().required('Question is required.'),
          answer: Yup.string().required('Answer is required.'),
        })
      ),

    })
  ),
});

export default faqSchema;